export default __webpack_public_path__ + "static/media/EmptyPlatform.256.d642886b.png";